import { render, staticRenderFns } from "./Etransfer.vue?vue&type=template&id=250105b8&"
import script from "./Etransfer.vue?vue&type=script&lang=js&"
export * from "./Etransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports